"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var React = require("react");
var classNames = require("classnames");
var MegaMenuSearchAction_1 = require("@/pages/common/actions/MegaMenuSearchAction");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var mapStateToProps = function (state) { return (__assign(__assign({}, state.layout.megamenusearch), { lang: state.layout.language.languages
        .filter(function (it) { return it.id === state.layout.language.current; })[0]
        .code1.toLowerCase() })); };
var mapDispatchToProps = function (dispatch) { return ({
    onSearchIconClicked: function () { return dispatch(MegaMenuSearchAction_1.default.onSearchIconClicked()); },
    onCloseIconClicked: function () { return dispatch(MegaMenuSearchAction_1.default.onCloseIconClicked()); },
    onBackgroundClicked: function () { return dispatch(MegaMenuSearchAction_1.default.onBackgroundClicked()); },
    onSearchInputChanged: function (keyword) { return dispatch(MegaMenuSearchAction_1.default.onSearchInputChanged(keyword)); },
    onSearchButtonClicked: function () { return dispatch(MegaMenuSearchAction_1.default.onSearchButtonClicked()); },
    onSearchTypeClicked: function (type) { return dispatch(MegaMenuSearchAction_1.default.onSearchTypeClicked(type)); },
    onKeywordEnter: function () { return dispatch(MegaMenuSearchAction_1.default.onKeywordEnter()); },
    onKeywordEscape: function () { return dispatch(MegaMenuSearchAction_1.default.onKeywordEscape()); },
    onKeywordNext: function () { return dispatch(MegaMenuSearchAction_1.default.onKeywordNext()); },
    onKeywordPrevious: function () { return dispatch(MegaMenuSearchAction_1.default.onKeywordPrevious()); },
    onSuggestionClick: function (groupIndex, rowIndex) { return dispatch(MegaMenuSearchAction_1.default.onSuggestionClick(groupIndex, rowIndex)); },
    onSuggestionMouseOver: function (groupIndex, rowIndex) { return dispatch(MegaMenuSearchAction_1.default.onSuggestionMouseOver(groupIndex, rowIndex)); },
}); };
var megaMenuSearchPopup = function (props) {
    var popupClass = classNames(['l-mega__search-popup', { 'l-mega__search-popup--active': props.active }]);
    var buyTypeClass = classNames(['c-searchpop__type', { 'c-searchpop__type--active': props.type === SfilterTypeGroup_1.SfilterType.BUY }]);
    var rentTypeClass = classNames(['c-searchpop__type', { 'c-searchpop__type--active': props.type === SfilterTypeGroup_1.SfilterType.RENT }]);
    var fullscreenloadingClass = classNames(['c-searchpop__fullscreen-loading', { 'c-searchpop__fullscreen-loading--active': props.fullscreenloading }]);
    var t = props.t;
    var onPopupBackgroundClicked = function (e) {
        if (e.target !== e.currentTarget)
            return;
        props.onBackgroundClicked();
    };
    var onBuyClicked = function () { return props.onSearchTypeClicked(SfilterTypeGroup_1.SfilterType.BUY); };
    var onRentClicked = function () { return props.onSearchTypeClicked(SfilterTypeGroup_1.SfilterType.RENT); };
    var onSearchButtonClicked = function () { return props.onSearchButtonClicked(); };
    var onKeywordChanged = function (event) { return props.onSearchInputChanged(event.target.value); };
    var onKeyDown = function (props) { return function (event) {
        if (event.key.toLowerCase() === 'enter') {
            event.preventDefault();
            return props.onKeywordEnter();
        }
        if (event.key.toLowerCase() === 'escape') {
            event.preventDefault();
            return props.onKeywordEscape();
        }
        if (event.key.toLowerCase() === 'arrowup') {
            event.preventDefault();
            return props.onKeywordPrevious();
        }
        if (event.key.toLowerCase() === 'arrowdown') {
            event.preventDefault();
            return props.onKeywordNext();
        }
    }; };
    var isLoading = props.suggestionLoading;
    var renderSuggestions = function (props) {
        var renderSuggestionRow = function (groupIndex, rowIndex, currentGroupIndex) { return function (item, i) {
            var isCurrentGroupIndex = groupIndex === currentGroupIndex;
            var isCurrentGroupAndRow = rowIndex === i && isCurrentGroupIndex;
            var rowClass = classNames(['c-searchpop__row', { 'c-searchpop__row--active': isCurrentGroupAndRow }]);
            var onItemClick = function () { return props.onSuggestionClick(groupIndex, rowIndex); };
            var onMouseOver = function () { return props.onSuggestionMouseOver(groupIndex, rowIndex); };
            return (React.createElement("div", { onClick: onItemClick, key: i, className: rowClass, onMouseOver: onMouseOver },
                React.createElement("span", null, item.name)));
        }; };
        var renderSuggestionGroup = function (groupIndex, rowIndex) { return function (suggestionGroup, i) {
            return (React.createElement("div", { className: "c-searchpop__group" },
                React.createElement("div", { className: "c-searchpop__name" }, suggestionGroup.name),
                React.createElement("div", { className: "c-searchpop__rows" }, suggestionGroup.suggestions.map(renderSuggestionRow(groupIndex, rowIndex, i)))));
        }; };
        return (React.createElement("div", { className: "c-searchpop__suggestions" }, props.suggestionGroups.map(renderSuggestionGroup(props.suggestionGroupIndex, props.suggestionRowIndex))));
    };
    return (React.createElement("div", { className: popupClass, onClick: onPopupBackgroundClicked },
        React.createElement("div", { className: "c-searchpop" },
            React.createElement("div", { className: "c-searchpop__body" },
                React.createElement("a", { onClick: props.onCloseIconClicked, className: "c-searchpop__close" },
                    React.createElement("span", { className: "fal fa-times" })),
                React.createElement("div", { className: "c-searchpop__types" },
                    React.createElement("a", { onClick: onBuyClicked, className: buyTypeClass }, t.buy),
                    React.createElement("a", { onClick: onRentClicked, className: rentTypeClass }, t.rent)),
                React.createElement("div", { className: "c-searchpop__input" },
                    React.createElement("input", { id: "megasearch-input", type: "search", placeholder: t.placeholder, value: props.keyword, onChange: onKeywordChanged, onKeyDown: onKeyDown(props) }),
                    React.createElement("button", { onClick: onSearchButtonClicked, className: "far fa-search" })),
                isLoading ? (React.createElement("div", { className: "c-searchpop__loading" },
                    React.createElement("span", { className: "fal fa-spinner fa-spin" }))) : renderSuggestions(props)),
            React.createElement("div", { className: fullscreenloadingClass },
                React.createElement("span", { className: "fal fa-spin fa-spinner" })))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(megaMenuSearchPopup);
